"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function detectPageVisibilityApi(document) {
    var hiddenAttribute;
    var visibilityChangeEvent;
    if (typeof document.hidden !== 'undefined') {
        hiddenAttribute = 'hidden';
        visibilityChangeEvent = 'visibilitychange';
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        hiddenAttribute = 'webkitHidden';
        visibilityChangeEvent = 'webkitvisibilitychange';
    }
    return { hiddenAttribute: hiddenAttribute, visibilityChangeEvent: visibilityChangeEvent };
}
exports.detectPageVisibilityApi = detectPageVisibilityApi;
